<template>
  <div>
    <div class="tile is-ancestor">
      <div
        class="tile is-parent is-2"
        v-for="item in menu"
        v-if="!item.meta.nomenu"
        :key="item.meta.label"
      >
        <article class="tile is-child box">
          <router-link :to="item.path">
            <p class="title">{{ item.meta.label || item.name }}</p>
            <div class="sub-children">
              <p
                class="subtitle"
                v-for="subItem in item.children"
                v-if="!subItem.meta.nomenu"
                :key="subItem.meta.label"
              >
                <router-link :to="item.path + '/' + subItem.path">
                  {{ subItem.meta.label }}
                </router-link>
              </p>
            </div>
          </router-link>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: mapGetters({
        menu: 'menuitems'
    }),
    data() {
        return {}
    }
}
</script>

<style lang="less" scoped>
body > .el-container {
  background-color: #f8f8fa;
  height: 100%;
  .isCollapse {
    position: absolute;
    left: 250px;
    top: 20px;
    font-size: 18px !important;
  }
}

.max-container {
  height: 100%;
}

.main-container {
  margin-top: 60px;
}

.el-header {
  padding: 10px;
  text-align: right;
  background: #fff;
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  z-index: 10;
  box-shadow: 2px 2px 2px #ccc;
  line-height: 40px;
  h1 {
    color: #00b593;
    font-size: 17px;
    font-weight: bold;
    float: left;
    display: inline;
    width: 128px;
  }
  span {
    font-size: 14px;
  }

  .logo-box {
    background: url('../assets/img/logo.png') no-repeat;
    display: inline;
    float: left;
    font-size: 19px;
    color: #00b593;
    padding-left: 220px;
  }
}

.el-aside {
  .el-menu {
    color: #333;
    height: 100%;
    _max-height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }
}

.el-main {
}
</style>



// WEBPACK FOOTER //
// Home.vue?0a7e7840